import { Link } from "react-router-dom";
import { getHotMedia, typeLabels } from "@/utils/media";

export default function HotRanking() {
  const items = getHotMedia(8);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <i className="ri-bar-chart-box-line text-accent-500"></i>
        热度榜单
      </h2>
      <p className="mt-1 text-xs text-foreground-500">实时热度排名，看看大家都在追什么</p>
      <ul className="mt-4 space-y-1">
        {items.map((item, i) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  i < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="h-12 w-9 shrink-0 overflow-hidden rounded bg-background-200">
                <img
                  src={item.poster}
                  alt={item.title}
                  title={`${item.title} 海报`}
                  className="h-full w-full object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900">
                  {item.title}
                </span>
                <span className="block truncate text-xs text-foreground-500">
                  {typeLabels[item.type]} · {item.region}
                </span>
              </span>
              <span className="shrink-0 text-sm font-semibold text-accent-600">
                {item.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}